export class  RemittanceEntry {
  constructor(
    public Payment_BatchId?: string,
    public Batch_SequenceNumber: number = 0,
    public Check_Ref_Number: number = 0,
    public Payer_ShardPayerIdentifier: string = '',
    public Location_CorporateLocationNumber: string = '',
    public StoreId: string = '',
    public Prescription_PrescriptionNumber: string = '',
    public Prescription_FillDate: Date = new Date(),
    public Money_PaidAmount: number = 0.00,
    public Adjustment_Code_1: string = '',
    public Adjustment_Code_2: string = '',
    public Adjustment_Code_3: string = '',
    public Adjustment_Code_4: string = '',
    public Adjustment_Code_5: string = '',
    public Adjustment_Code_6: string = '',
    public Adjustment_Code_7: string = '',
    public Adjustment_Code_8: string = '',
    public Adjustment_Code_9: string = '',
    public Adjustment_Code_10: string = '',
    public Valid_Posted_Claim: string = '',
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/models/remittance-entry.model.ts